<template>
    <div id="messages" v-if="messages !== null">
      <b-alert
        v-model="showDismissibleAlert"
        :variant="defineVariant"
        dismissible> 
        
        <p class="mb-0" v-for="e in messages.errors" :key="e.message" >
            <span v-html="e"></span>
        </p>
        
      </b-alert>
    </div>
</template>
<script>
export default {
  name: "Messages",
  computed: {
    messages: {
      get() {
        return this.$store.getters.getMessages;
      }
    },
    defineVariant() {
      
      if (this.messages.variant != null) {
        return this.messages.variant;
      } else {
        return 'danger';
      }
    },
    showDismissibleAlert: {
      get() {
        if (this.messages.message) {
          return true;
        } else {
          return false;
        }
      },
      set() {
        this.$store.commit("setMessages", "");
        return true;
      }
    }
  }
};
</script>